import { useState } from 'react'

import { RequestStatus } from 'core/domain/Request'
import { type HttpClientError } from 'core/infra/http/HttpClient'

import { acceptBid } from 'legacy/services/bids'

export function useAcceptBid() {
  const [requestStatus, setRequestStatus] = useState<RequestStatus>(RequestStatus.Initial)
  const [errorCode, setErrorCode] = useState<number | undefined>()

  function acceptBidFn(uuid: string) {
    setRequestStatus(RequestStatus.Pending)
    return acceptBid(uuid)
      .then(() => {
        setRequestStatus(RequestStatus.Done)
      })
      .catch((error: HttpClientError<unknown>) => {
        setErrorCode(error.response?.status)
        setRequestStatus(RequestStatus.Error)
      })
  }

  return {
    acceptBid: acceptBidFn,
    isAccepting: requestStatus === RequestStatus.Pending,
    hasAccepted: requestStatus === RequestStatus.Done,
    acceptedBidErrorCode: errorCode,
  }
}
